export default __webpack_public_path__ + "assets/67a7d9184783abaf8330bb16232e8333.jpg";